module.exports = __webpack_public_path__ + "static/media/shapes2.41dc5e82.png";